import $ from 'jquery';

let getSiteLanguage = function () {
    let language = 'et';

    if ($('html').attr('lang') == 'en-US') {
        language = 'en';
    } else if ($('html').attr('lang') == 'lv-LV') {
        language = 'lv';
    } else if ($('html').attr('lang') == 'lt-LT') {
        language = 'lt';
    }

    return language;
};

export default getSiteLanguage;
